import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';

import { objToArr } from '../../helpers';

import CenteredWrapper from '../../components/CenteredWrapper';
import BasicLayout from '../BasicLayout';

import OrganizationsMenu from '../../components/OrganizationsMenu';
import OrganizationsContent from '../../components/OrganizationsContent';
import LoadingOverlay from '../../components/LoadingOverlay';

class Organizations extends React.Component {
  deleteOrganization(event, organizationId) {
    event.preventDefault();

    this.props.firebase.remove(`organizations/${organizationId}`).then((snapshot) => {
      console.log('organization removed', snapshot);
    });
  }

  renderLoading() {
    return <LoadingOverlay />;
  }

  renderFull() {
    const { organizations } = this.props;

    const styles = {
      wrapper: {
        width: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'space-between',
        alignItems: 'stretch',
      },
      menu: {
        display: 'flex',
        flex: '0 1 240px',
        backgroundColor: 'rgb(245, 245, 245)',
      },
    };

    return (
      <CenteredWrapper align="center" width={780} style={{ margin: '20px auto' }}>
        <div style={styles.wrapper}>
          <OrganizationsMenu style={styles.menu} organizations={organizations} />
          <OrganizationsContent organizations={organizations} />
        </div>
      </CenteredWrapper>
    );
  }

  render() {
    const { match, isRequesting } = this.props;

    const render = () => {
      if (isRequesting === true) {
        return this.renderLoading();
      }

      return this.renderFull();
    };

    return (
      <BasicLayout match={match} searchEnabled={false} toolbar={<div>Organizations</div>}>
        {render()}
      </BasicLayout>
    );
  }
}

const populates = [
  { child: 'createdBy', root: 'users' },
  { child: 'members', root: 'users' },
  { child: 'owners', root: 'users' },
];

export default compose(
  connect(({ firebase, router }) => ({
    auth: firebase.auth,
  })),
  firebaseConnect((props, firebase) => [
    {
      path: '/organizations',
      populates,
      queryParams: [`orderByChild=members/${props.auth.uid}`, 'equalTo=true'],
    },
  ]),
  connect(({ firebase, router }) => ({
    organizations: objToArr(firebase.data.organizations),
    isRequesting: firebase.requesting.organizations,
    location: router.location,
    projectsRequested: firebase.requested.projects,
  })),
)(Organizations);



// WEBPACK FOOTER //
// ./src/containers/Organization/Organization.js